"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const smart_home_1 = require("@soluto-private/smart-home");
exports.AmEnrollmentState = smart_home_1.AmEnrollmentState;
exports.HorizonEnrollmentProgress = smart_home_1.HorizonEnrollmentProgress;
exports.HorizonEnrollmentState = smart_home_1.HorizonEnrollmentState;
var Partners;
(function (Partners) {
    Partners["Verizon"] = "Verizon";
})(Partners = exports.Partners || (exports.Partners = {}));
var ProductNames;
(function (ProductNames) {
    ProductNames["VPH"] = "vph";
})(ProductNames = exports.ProductNames || (exports.ProductNames = {}));
var AttributeTypes;
(function (AttributeTypes) {
    AttributeTypes["SmartHome"] = "smart-home";
    AttributeTypes["SalesTag"] = "salesTag";
    AttributeTypes["TailoredSales"] = "tailored-sales";
    AttributeTypes["DevTailoredSales"] = "dev-tailored-sales";
    AttributeTypes["DevOfferDetection"] = "dev-offer-detection";
    AttributeTypes["OfferDetection"] = "offer-detection";
    AttributeTypes["DevResolutionDetection"] = "dev-resolution-detection";
    AttributeTypes["ResolutionDetection"] = "resolution-detection";
    AttributeTypes["DevSalesInteractions"] = "dev-sales-interactions";
    AttributeTypes["SalesInteractions"] = "sales-interactions";
    AttributeTypes["CustomerDetails"] = "customer-details";
    AttributeTypes["DevOfferRecommendations"] = "dev-offer-recommendations";
    AttributeTypes["OfferRecommendations"] = "offer-recommendations";
    AttributeTypes["DevCustomerSentiment"] = "dev-customer-sentiment";
    AttributeTypes["CustomerSentiment"] = "customer-sentiment";
    AttributeTypes["AmEnrollmentProgress"] = "am-enrollment-progress";
})(AttributeTypes = exports.AttributeTypes || (exports.AttributeTypes = {}));
var AttributeKeys;
(function (AttributeKeys) {
    AttributeKeys["CustomerGraph"] = "customer-graph";
    AttributeKeys["Sales"] = "sales";
    AttributeKeys["SalesStubData"] = "sales-stub-data";
    AttributeKeys["Keywords"] = "keywords";
    AttributeKeys["Recommendations"] = "recommendations";
    AttributeKeys["Polarity"] = "polarity";
})(AttributeKeys = exports.AttributeKeys || (exports.AttributeKeys = {}));
var SalesInteractionStatus;
(function (SalesInteractionStatus) {
    SalesInteractionStatus["Success"] = "SUCCESS";
    SalesInteractionStatus["Loading"] = "LOADING";
})(SalesInteractionStatus = exports.SalesInteractionStatus || (exports.SalesInteractionStatus = {}));
var ExternalEnrollmentProgress;
(function (ExternalEnrollmentProgress) {
    ExternalEnrollmentProgress["Disclosure"] = "DISCLOSURE";
    ExternalEnrollmentProgress["EnrollmentConfirmation"] = "ENROLLMENT_CONFIRMATION";
    ExternalEnrollmentProgress["Loading"] = "LOADING";
    ExternalEnrollmentProgress["Success"] = "SUCCESS";
    ExternalEnrollmentProgress["Error"] = "ERROR";
})(ExternalEnrollmentProgress = exports.ExternalEnrollmentProgress || (exports.ExternalEnrollmentProgress = {}));
exports.defaultHorizonEnrollmentUrlProps = {
    baseUrl: '',
    sessionIdParam: '',
    expertIdParam: '',
    sourceAppParam: '',
};
var OfferType;
(function (OfferType) {
    OfferType["Automatic"] = "Automatic";
    OfferType["Manual"] = "Manual";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var SalesTag;
(function (SalesTag) {
    SalesTag["Unknown"] = "unknown";
    SalesTag["Eligible"] = "eligible";
    SalesTag["Ineligible"] = "ineligible";
    SalesTag["Offered"] = "offered";
    SalesTag["Enrolled"] = "enrolled";
})(SalesTag = exports.SalesTag || (exports.SalesTag = {}));
var SalesTagText;
(function (SalesTagText) {
    SalesTagText["Unknown"] = "Sales eligibility unknown";
    SalesTagText["Eligible"] = "Eligible for sales";
    SalesTagText["Ineligible"] = "Ineligible for sales";
    SalesTagText["Offered"] = "Offered";
    SalesTagText["Enrolled"] = "Enrolled ";
})(SalesTagText = exports.SalesTagText || (exports.SalesTagText = {}));
exports.SalesTagMap = {
    [SalesTag.Unknown]: {
        tagText: SalesTagText.Unknown,
        backgroundColor: '#FFCB05',
        textColor: 'black',
    },
    [SalesTag.Eligible]: {
        tagText: SalesTagText.Eligible,
        backgroundColor: '#68DC72',
        textColor: 'black',
    },
    [SalesTag.Ineligible]: {
        tagText: SalesTagText.Ineligible,
        backgroundColor: '#EA3661',
        textColor: 'black',
    },
    [SalesTag.Offered]: {
        tagText: SalesTagText.Offered,
        backgroundColor: '#4AA8FF',
        textColor: 'black',
    },
    [SalesTag.Enrolled]: {
        tagText: SalesTagText.Enrolled,
        backgroundColor: '#EF8BF8',
        textColor: 'black',
    },
};
var PartnerMapping;
(function (PartnerMapping) {
    PartnerMapping["Verizon"] = "verizon";
})(PartnerMapping = exports.PartnerMapping || (exports.PartnerMapping = {}));
